
import { motion } from "framer-motion";

export const LoanBenefitsSectionSv = () => {
  return (
    <motion.div
      className="bg-blue-50 p-6 rounded-lg mb-8"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.1 }}
    >
      <h2 className="text-xl font-semibold mb-4 text-blue-700">Spara pengar genom att jämföra ditt lån</h2>
      <p className="text-gray-700 mb-4">
        Med Lainasampo.fi kan du enkelt och snabbt jämföra olika lån. 
        Fyll i en ansökan och få erbjudanden från flera banker.
      </p>
      
      <div className="space-y-4 mt-6">
        <div className="bg-white p-4 rounded-lg shadow-sm">
          <h3 className="font-medium text-blue-700 mb-2">Spara tid och ansträngning</h3>
          <p className="text-gray-600">
            Med Lainasampo.fi kan du jämföra erbjudanden från över 30 banker och finansinstitut med en enda ansökan. 
            Detta sparar avsevärd tid jämfört med att ansöka om lån från varje bank separat.
          </p>
        </div>
        
        <div className="bg-white p-4 rounded-lg shadow-sm">
          <h3 className="font-medium text-blue-700 mb-2">Kostnadsfri tjänst</h3>
          <p className="text-gray-600">
            Vår tjänst är helt kostnadsfri för dig. Vi finansierar vår verksamhet genom provisioner som betalas av banker och 
            finansinstitut, så du kan använda vår tjänst utan att oroa dig för extra kostnader.
          </p>
        </div>
        
        <div className="bg-white p-4 rounded-lg shadow-sm">
          <h3 className="font-medium text-blue-700 mb-2">Tillförlitlig jämförelse</h3>
          <p className="text-gray-600">
            Vi jämför alla lånekostnader, räntor och villkor åt dig. Du får en tydlig sammanfattning av de olika 
            alternativen, vilket gör att du kan fatta ett beslut enkelt och snabbt.
          </p>
        </div>
      </div>
    </motion.div>
  );
};
